import React from 'react'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'

const BigText = ({ content }) => {
  return (
    <>
      <section className='big-text'>
        { content &&
          <Fade distance='40px' bottom>
            <div className='big-text__inner'>
              {parse(content)}
            </div>
          </Fade>
        }
      </section>
    </>
  )
}

export default BigText